import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acef5608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider" }
const _hoisted_2 = ["src"]

import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  sliderOptions: ['dart', 'elastic', 'flutter', 'graphql', 'hasura', 'laravel',
    'nest', 'next', 'postgres', 'python', 'pytorch', 'questdb', 'react', 'rust',
    'swift', 'tensor-flow', 'ts', 'vue'],
  currentSlide: 2,
  slideWidth: null,
  sliderWidth: null,
  loopCounter: 0
})
setTimeout(() => {
  data.slideWidth = document.getElementsByClassName('slider-slide')[0].getBoundingClientRect().width
  data.sliderWidth = document.getElementsByClassName('slider')
}, 1000)

function playSlideAnimation() {
  for (let i = 0; i < data.sliderOptions.length; i++) {
    setTimeout(() => {
      if (i === data.sliderOptions.length - 2) {
        data.currentSlide = 0
        data.sliderWidth[0].setAttribute('style', 'transform: translateX(0px)')
        playSlideAnimation()
      } else {
        data.sliderWidth[0].setAttribute('style', `transform: translateX(-${data.slideWidth * i}px)`)
        data.currentSlide++
      }
    }, 4000 * i)
  }
}
playSlideAnimation()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).sliderOptions, (item, index) => {
      return (_openBlock(), _createElementBlock("img", {
        key: index,
        class: _normalizeClass(["slider-slide", {active: _unref(data).currentSlide === index}]),
        src: require(`@/assets/images/tech-icons/${item}.svg`),
        alt: ""
      }, null, 10, _hoisted_2))
    }), 128))
  ]))
}
}

})